import { useEffect, useMemo, useState } from 'react';
// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
import DefaultLayout from '../../layout/DefaultLayout';
import UniversalRecordTable from '../../components/Tables/universalRecord/UniversalRecordTable';
import { useSupplier } from '../../hooks/useSupplier';
import { buildSupplierFilters } from '../../features/supplier/buildSupplierFilters';
import { supplierColumns } from '../../features/supplier/supplierColumns';
import SupplierRegistrationPopup from '../../components/Supplier/SupplierRegistrationPopup';
import SupplierEditPopup from '../../components/Supplier/SupplierEditPopup';
import SupplierViewPopup from '../../components/Supplier/SupplierViewPopup';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import { UniversalFilterConfig } from '../../components/Filters/ReportFilter';

const SupplierPage = () => {
  const {
    list,
    paginator,
    fetchSuppliersPaged,
    fetchFilteredSuppliers,
    handlerClearFilteredSuppliers,
    loadSupplierById,
    loadSupplierForEdit,
    showRegistrationModal,
    openAddModal,
    closeAddModal,
    toggleStatus,
    saveSupplier,
    showViewModal,
    closeViewModal,
    showEditModal,
    closeEditModal,
  } = useSupplier();

  const [filters, setFilters] = useState<any>({});
  const [filtersApplied, setFiltersApplied] = useState(false);

  const pageSize = paginator?.size || 10;
  const currentPage = paginator?.number || 0;

  useEffect(() => {
    fetchSuppliersPaged(currentPage, pageSize);
  }, []);

  const columns = useMemo(() => supplierColumns, []);

  const filterFields: UniversalFilterConfig[] = useMemo(
    () => buildSupplierFilters(),
    []
  );

  const buildSupplierFilterPayload = (rawFilters: any) => {
    const payload: any = {};

    if (rawFilters.name) payload.name = rawFilters.name;
    if (rawFilters.nit) payload.nit = rawFilters.nit;
    if (rawFilters.nrc) payload.nrc = rawFilters.nrc;
    if (rawFilters.phone) payload.phone = rawFilters.phone;
    if (rawFilters.email) payload.email = rawFilters.email;
    if (rawFilters.tradeName) payload.tradeName = rawFilters.tradeName;
    // agrega aquí los demás campos según los filtros definidos para proveedores

    return payload;
  };

  const handleFilterChange = (newFilters: any) => {
    const payload = buildSupplierFilterPayload(newFilters);
    setFilters(payload);
    setFiltersApplied(true);
    fetchFilteredSuppliers(payload, 0, pageSize);
  };

  const handlePageChange = (page: number) => {
    if (filtersApplied) {
      fetchFilteredSuppliers(filters, page, pageSize);
    } else {
      fetchSuppliersPaged(page, pageSize);
    }
  };

  const handlePageSizeChange = (size: number) => {
    if (filtersApplied) {
      fetchFilteredSuppliers(filters, 0, size);
    } else {
      fetchSuppliersPaged(0, size);
    }
  };

  const getActions = (row: any) => {
    return [
      {
        key: 'view',
        label: 'Ver',
        onClick: async () => {
          await loadSupplierById(row.id);
        },
      },
      {
        key: 'edit',
        label: 'Editar',
        onClick: async () => {
          await loadSupplierForEdit(row.id);
        },
      },
      {
        key: 'cancel',
        label: row.status ? 'Desactivar' : 'Activar',
        onClick: async () => {
          await toggleStatus(row.id);
        },
      },
    ];
  };

  return (
    <DefaultLayout>
      {/* <Breadcrumb pageName="Configuración de Proveedores" /> */}
      <BreadcrumbTwo />


      <UniversalRecordTable
        columns={columns}
        data={list}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        paginator={paginator}
        showPagination={true}
        enableRowClick={true}
        pageSize={pageSize}
        noDataMessage="Utiliza los filtros para encontrar proveedores específicos."
        topRightAction={{
          label: 'Nuevo Proveedor',
          onClick: openAddModal,
        }}
        getActions={getActions}
        filtersConfig={filterFields}
        onFilterChange={handleFilterChange}
        onResetFilters={handlerClearFilteredSuppliers}
      />

      {/* Modal para registrar un nuevo proveedor */}
      <SupplierRegistrationPopup
        isOpen={showRegistrationModal}
        onClose={closeAddModal}
        onSubmit={saveSupplier}
      />

      {/* Modal para editar proveedor */}
      <SupplierEditPopup
        isOpen={showEditModal}
        onClose={closeEditModal}
        onSubmit={saveSupplier}
      />

      {/* Modal para ver detalle de proveedor */}
      <SupplierViewPopup
        isOpen={showViewModal}
        onClose={closeViewModal}
      />
    </DefaultLayout>
  );
};

export default SupplierPage;
